import { all } from "redux-saga/effects";
import authSagas from "./auth/saga";
import userSagas from "./user/saga";
import doctorsSagas from "./doctors/saga";
import patientsSagas from "./patients/saga";
import kitsSagas from "./kits/saga";
import holdedSagas from "./holded/saga";
import stripeSagas from "./stripe/saga";

export default function* rootSaga(getState) {
  yield all([
    authSagas(),
    userSagas(),
    doctorsSagas(),
    patientsSagas(),
    kitsSagas(),
    holdedSagas(),
    stripeSagas(),
  ]);
}
